// extracted by mini-css-extract-plugin
export default {"container":"NoFinishid_container__vw40E","box":"NoFinishid_box__fPO9o","noOngoingImg":"NoFinishid_noOngoingImg__CELBJ","noOngoingText":"NoFinishid_noOngoingText__-pJHa"};